import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { IZoomUser } from '../../../api/zoom.dao';

interface IZoomUsersManagementRowProps {
    zoomUser: IZoomUser;
    isTracked: boolean;
    toggleSelection: () => void;
    pendingStartTracking: boolean;
    pendingStopTracking: boolean;
}

const ZoomUsersManagementRow = (props: IZoomUsersManagementRowProps) => {
    const { email, last_name, first_name, groups } = props.zoomUser;

    let modifier = '';
    if (props.pendingStartTracking) {
        modifier = ' zoom-user-management-row--pending-start';
    }

    if (props.pendingStopTracking) {
        modifier = ' zoom-user-management-row--pending-stop';
    }

    return (
        <tr className={'zoom-user-management-row' + modifier}>
            <td className='buttons-cell'>
                <input
                    type='checkbox'
                    checked={props.isTracked}
                    onChange={props.toggleSelection}
                />
            </td>
            <td>{email}</td>
            <td>{first_name}</td>
            <td>{last_name}</td>
            <td>{groups ? groups.map(e => e.name).join(', ') : ''}</td>
        </tr>
    );
};

const ZoomUsersManagementRowObserver = mobxReact.observer((props: {rowProps: IZoomUsersManagementRowProps}) => {
    return <ZoomUsersManagementRow {...props.rowProps} />;
});

export { ZoomUsersManagementRowObserver, IZoomUsersManagementRowProps };
